import { styled } from '@mui/material/styles';
const PREFIX = 'Dashboard';
export const classes = {
    root: `${PREFIX}-root`,
    main: `${PREFIX}-main`,
    content: `${PREFIX}-content`,
    contentContainer: `${PREFIX}-contentContainer`,
};
const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    [`& .${classes.main}`]: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'hidden',
        margin: theme.spacing(2),
        marginLeft: 0,
        backgroundColor: theme.palette.background.paper,
    },
    [`& .${classes.content}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingRight: theme.spacing(2),
        overflow: 'auto',
    },
    [`& .${classes.contentContainer}`]: {},
}));
export default Root;
//# sourceMappingURL=styled.js.map